import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, MenuItem } from "react-pro-sidebar";
import { api_path } from "../shared";

// ✅ Import icons จาก MUI
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EventNoteIcon from "@mui/icons-material/EventNote";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PublicIcon from "@mui/icons-material/Public";
import DescriptionIcon from "@mui/icons-material/Description";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import InsightsIcon from "@mui/icons-material/Insights";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";

const DashboardMenu = ({ USER_ROLE,BU_LEADER }) => {
  const [menuList, setMenuList] = useState([]);
  const sectionStyle = {
    fontSize: "13px",
    fontWeight: 600,
    textTransform: "uppercase",
    color: "#0078d4",
    letterSpacing: "0.2px",
    margin: "20px 12px 6px",
    paddingBottom: "4px",
    borderBottom: "1px solid #e5e7eb",
  };
  return (
    <>
      <div style={sectionStyle}>Customer Management</div>
      <Menu
        menuItemStyles={{
          button: ({ level, active }) => {
            if (level === 0 || level === 1)
              return {
                backgroundColor: active
                  ? "rgba(30, 167, 253, 0.15)"
                  : "#FFFFFF",
                color: "#000000",
              };
          },
        }}
      >
        {(USER_ROLE == 7 ||
          USER_ROLE == 3 ||
          USER_ROLE == 14 ||
          (USER_ROLE == 1 && BU_LEADER == 1)) && (
          <MenuItem
            href="/s-crm/CampaignManagement"
            icon={<InsightsIcon fontSize="small" />}
            className="menuItem"
          >
            Campaign Management
          </MenuItem>
        )}
        {(USER_ROLE == 1 ||
          USER_ROLE == 2 ||
          USER_ROLE == 7 ||
          USER_ROLE == 14) && (
          <MenuItem
            href="/s-crm/Customer"
            icon={<PersonOutlineIcon fontSize="small" />}
            className="menuItem"
          >
            Check Duplicate
          </MenuItem>
        )}

        <MenuItem
          href="/s-crm/Customers"
          icon={<PersonOutlineIcon fontSize="small" />}
          className="menuItem"
        >
          Customer Profile
        </MenuItem>

        <MenuItem
          href="/s-crm/SaleActivity"
          icon={<EventNoteIcon fontSize="small" />}
          className="menuItem"
        >
          Sales Activity
        </MenuItem>

        <div style={sectionStyle}>Pricing</div>
        <MenuItem
          href="https://sinoconnect.sharepoint.com/sites/ProcurementTeam/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FProcurementTeam%2FShared%20Documents%2FUSA%20COSTSHEET&p=true&ga=1"
          icon={<AttachMoneyIcon fontSize="small" />}
          target="_blank"
          rel="noopener noreferrer"
          className="menuItem"
        >
          Cost Sheet USA
        </MenuItem>

        <MenuItem
          href="/s-crm/CostSheet"
          icon={<PublicIcon fontSize="small" />}
          className="menuItem"
        >
          Cost Sheet Non-USA
        </MenuItem>

        <MenuItem
          href="/s-crm/ServiceContract"
          icon={<DescriptionIcon fontSize="small" />}
          className="menuItem"
        >
          Services Contract
        </MenuItem>

        <MenuItem
          href="/s-crm/SaleInquiry"
          icon={<QuestionAnswerIcon fontSize="small" />}
          className="menuItem"
        >
          Sales Inquiry
        </MenuItem>

        <MenuItem
          href="/s-crm/Bookings"
          icon={<CalendarMonthIcon fontSize="small" />}
          className="menuItem"
        >
          Preserve Booking
        </MenuItem>
        {USER_ROLE != 9 && (
          <>
            <div style={sectionStyle}>Order</div>

            <MenuItem
              href="/s-crm/SalesOrder"
              icon={<ShoppingCartOutlinedIcon fontSize="small" />}
              className="menuItem"
            >
              Sales Order
            </MenuItem>

            <MenuItem
              href="https://forms.office.com/pages/responsepage.aspx?id=H3Ns2shuOkiPPK_ve8Kuh6NKBuEVJIVPk1Gc1WOJDrZUOUM1U1FRODVCV1RORFlVMllESDNFVUg3SiQlQCN0PWcu"
              icon={<FlightTakeoffIcon fontSize="small" />}
              target="_blank"
              rel="noopener noreferrer"
              className="menuItem"
            >
              Air Booking
            </MenuItem>
          </>
        )}

        <div style={sectionStyle}>Report & Other</div>
        <MenuItem
          href="/s-crm/Datamyne"
          icon={<InsightsIcon fontSize="small" />}
          className="menuItem"
        >
          Datamyne
        </MenuItem>

        <MenuItem
          href="/s-crm/AgentContact"
          icon={<ContactsOutlinedIcon fontSize="small" />}
          className="menuItem"
        >
          Agent Contact
        </MenuItem>

        <MenuItem
          href="https://sinoconnect.sharepoint.com/sites/Sino-SINOSalesDepartment-Group/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FSino%2DSINOSalesDepartment%2DGroup%2FShared%20Documents%2FSales%20Document&p=true&ga=1"
          icon={<FolderOpenIcon fontSize="small" />}
          target="_blank"
          rel="noopener noreferrer"
          className="menuItem"
        >
          Sales Document
        </MenuItem>
  <MenuItem
          href="https://teams.microsoft.com/l/channel/19%3A86c9bd61244d46bfb976a3883f4038a1%40thread.tacv2/Sales%20Announcements?groupId=b3dffb5e-d896-4444-893c-950807d91f92&tenantId=da6c731f-6ec8-483a-8f3c-afef7bc2ae87"
          icon={<FolderOpenIcon fontSize="small" />}
          target="_blank"
          rel="noopener noreferrer"
          className="menuItem"
        >
          Sales Annoucement
        </MenuItem>
          <MenuItem
          href="https://teams.microsoft.com/l/chat/19:393ae2630e194618a2864388ecddfdf7@thread.customer/conversations?context=%7B%22contextType%22%3A%22chat%22%7D"
          icon={<FolderOpenIcon fontSize="small" />}
          target="_blank"
          rel="noopener noreferrer"
          className="menuItem"
        >
       One Agent Single Contact
        </MenuItem>
          <MenuItem
          href="https://teams.microsoft.com/l/chat/19:393ae2630e194618a2864388ecddfdf7@thread.v2/conversations?context=%7B%22contextType%22%3A%22chat%22%7D"
          icon={<FolderOpenIcon fontSize="small" />}
          target="_blank"
          rel="noopener noreferrer"
          className="menuItem"
        >
         Market Update
        </MenuItem>
        <MenuItem
          href="/s-crm/Register"
          icon={<AccountCircleIcon fontSize="small" />}
          className="menuItem"
        >
          Your Profile
        </MenuItem>

        <MenuItem
          href="/s-crm/logout"
          icon={<LogoutIcon fontSize="small" />}
          className="menuItem"
        >
          Sign out
        </MenuItem>
      </Menu>
    </>
  );
};

export default DashboardMenu;
